// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__Cl3Pw","row":"ProcedureTreatmentSummary_row__3ukxa"};